import { BusinessError } from './businessError';

export class RequestEntityTooLarge extends BusinessError {
    public name = 'RequestEntityTooLarge';
}
